import type { CSSProperties } from 'react';
import type { ApplicantStatus } from '../types';

const STATUS_CONFIG: Record<ApplicantStatus, { bg: string; color: string; label: string }> = {
  NEW:                        { bg: '#dbeafe', color: '#1e40af', label: 'Neu' },
  CONFIRMATION_SENT:          { bg: '#e0e7ff', color: '#3730a3', label: 'Bestätigung gesendet' },
  PHONE_INTERVIEW_SCHEDULED:  { bg: '#fef3c7', color: '#92400e', label: 'Interview geplant' },
  PHONE_INTERVIEW_DONE:       { bg: '#fde68a', color: '#78350f', label: 'Interview abgeschlossen' },
  TRIAL_SCHEDULED:            { bg: '#fbcfe8', color: '#9d174d', label: 'Probearbeiten geplant' },
  TRIAL_DONE:                 { bg: '#f9a8d4', color: '#831843', label: 'Probearbeiten abgeschlossen' },
  HIRED:                      { bg: '#dcfce7', color: '#166534', label: 'Eingestellt' },
  REJECTED:                   { bg: '#fee2e2', color: '#991b1b', label: 'Abgelehnt' },
};

const badgeStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '3px 10px',
  borderRadius: 9999,
  fontSize: 11,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

interface StatusBadgeProps {
  status: ApplicantStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps): React.JSX.Element {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.NEW;
  return (
    <span style={{ ...badgeStyle, background: config.bg, color: config.color }}>
      {config.label}
    </span>
  );
}
